import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'

import { Context } from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsContext'
import { Arrow, Pagination, PaginationContainer } from 'components/core/Acquiring/styles'
import { startGetCardAcquiringSettlements } from 'redux/acquiring/acquiring-actions'

const step = 10

const AcquiringChargesStepper = () => {
    const dispatch = useDispatch()
    const [pageSize, setPageSize] = useState(0)

    const { settlementsInputs, setSettlementsInputs, settlements, loader } = useContext(Context)

    useEffect(() => {
        dispatch(startGetCardAcquiringSettlements({ ...settlementsInputs, skip: pageSize, take: step }))
    }, [pageSize])

    const handleStepper = (way: boolean) => {
        setSettlementsInputs({ ...settlementsInputs, skip: pageSize, take: step })
        setPageSize(prevSize => (way ? prevSize + step : prevSize - step))
    }

    if (!!loader?.GET_CARD_ACQUIRING_SETTLEMENTS || (pageSize <= 0 && !settlements?.hasMore)) {
        return <></>
    }

    return (
        <PaginationContainer>
            <Pagination>
                <Arrow onClick={() => handleStepper(false)} hasPreviousPage={pageSize <= 0}>
                    <ArrowBackIos />
                </Arrow>
                <div>{(pageSize + step) / step}</div>
                <Arrow onClick={() => handleStepper(true)} hasNextPage={!settlements?.hasMore}>
                    <ArrowForwardIos />
                </Arrow>
            </Pagination>
        </PaginationContainer>
    )
}

export default AcquiringChargesStepper
